/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createAction, props } from '@ngrx/store';
import { ProjectDataActionsNames } from './project-data-action-names';
import { ParamCategory } from '../../models/add-project-parameter-category';
import { ProjectParameterDataItems } from '@hcworkspace/sysque/toolbelt/feature';
import { ProjectDataParamInfo } from '../../models/add-project-data-params-info';

export const GetParamCategory = createAction(
  ProjectDataActionsNames.GetParamCategory(),
  props<{ currentCategory: string }>()
);

export const GetParamCategorySuccess = createAction(
  ProjectDataActionsNames.GetParamCategorySuccess(),
  props<{ paramCategory: ParamCategory[] }>()
);

export const InitializeAddProjectParameters = createAction(ProjectDataActionsNames.InitializeAddProjectParameters());

export const InitializeAddProjectParametersSuccess = createAction(
  ProjectDataActionsNames.InitializeAddProjectParametersSuccess(),
  props<{ initialProjectParameterDataItems: ProjectParameterDataItems[] }>()
);

export const GetBuiltInGroupParameters = createAction(ProjectDataActionsNames.GetBuiltInGroupParameters());

export const GetBuiltInGroupParametersSuccess = createAction(
  ProjectDataActionsNames.GetBuiltInGroupParametersSuccess(),
  props<{ projectDataParamInfo: ProjectDataParamInfo[] }>()
);

export const GetDefinitionGroupParameters = createAction(ProjectDataActionsNames.GetDefinitionGroupParameters());

export const GetDefinitionGroupParametersSuccess = createAction(
  ProjectDataActionsNames.GetDefinitionGroupParametersSuccess(),
  props<{ projectDataParamInfo: ProjectDataParamInfo[] }>()
);
